import React from "react";
import Address from "./Address";
import Personal from "./Personal";

function ProfileComponent({ props }) {
  const {
    isPersonal,
    onMove,
    data,
    update,
    onChange,
    province,
    onSelect,
    city,
    district,
    area,
    isError,
    loading,
    onGender,
  } = props;
  return (
    <>
      <p className="header-title colors-blue font-semibold text-lg ">
        Pilih data yang ingin ditampilkan
      </p>
      <div className="flex items-center my-10">
        <div className="flex items-center">
          <div
            onClick={onMove}
            className={`${
              isPersonal === 1 ? "pro-active" : "pro-non-active"
            } p-3 rounded-3xl mr-4 cursor-pointer`}
          >
            <img
              src={
                isPersonal === 1
                  ? process.env.REACT_APP_BASE_URL +
                    "/assets/icon/ic_contact_blue.svg"
                  : process.env.REACT_APP_BASE_URL +
                    "/assets/icon/ic_contact_gray.svg"
              }
              alt="icon-contact-blue"
            />
          </div>
          {isPersonal === 1 && (
            <div className="mr-6">
              <p className="header-title-semi text-base colors-blue">
                Data Diri
              </p>
              <p className="header-content text-xs colors-gray">
                Data diri anda sesuai KTP
              </p>
            </div>
          )}
        </div>
        <div className="flex items-center">
          <div
            onClick={onMove}
            className={`${
              isPersonal === 0 ? "pro-active" : "pro-non-active"
            } p-3 rounded-3xl mr-4 cursor-pointer`}
          >
            <img
              src={
                isPersonal === 0
                  ? process.env.REACT_APP_BASE_URL +
                    "/assets/icon/ic_location_blue.svg"
                  : process.env.REACT_APP_BASE_URL +
                    "/assets/icon/ic_location_gray.svg"
              }
              alt="icon-location-blue"
            />
          </div>
          {isPersonal === 0 && (
            <div>
              <p className="header-title-semi text-base colors-blue">Alamat</p>
              <p className="header-content text-xs colors-gray">
                Alamat anda sesuai KTP
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Form Section */}
      {isPersonal === 1 ? (
        <Personal
          props={{ data, update, onChange, isError, loading, onGender }}
        />
      ) : (
        <Address
          props={{
            update,
            onChange,
            province,
            onSelect,
            city,
            district,
            area,
            isError,
            loading,
          }}
        />
      )}
    </>
  );
}

export default ProfileComponent;
